import { buildModule } from '../utils';

import list from './list';

export default buildModule()
	.withSubmodules({
		list,
	});
